import React from "react";
import "./StockOverview.css";

const StockOverview = () => {
  const cardsData = [
    {
      title: "SKUs in stock",
      value: "4,483",
      subtitle: "₹68.9L stock value",
    },
    {
      title: "Low stock",
      value: "13",
      subtitle: "2 critical · 4 caution",
    },
    {
      title: "Near expiry",
      value: "0",
      subtitle: "within 30 days",
    },
    {
      title: "Returns (period)",
      value: "17",
      subtitle: "line items — see Billing for invoice view",
    },
  ];

  return (
    <div className="stock-overview-container">
      <h2 className="stock-overview-title">Stock overview</h2>
      <div className="stock-overview-cards-grid">
        {cardsData.map((card, index) => (
          <div className="stock-overview-card" key={index}>
            <h4 className="stock-overview-card-title">{card.title}</h4>
            <div className="stock-overview-card-value-container">
              <h2 className="stock-overview-card-value">{card.value}</h2>
            </div>
            <div className="stock-overview-card-subtitle">
              {card.subtitle}
            </div>
          </div>
        ))}
      </div>
      <div className="stock-overview-footer-note">
        See Billing → Returns Report for the invoice-level view.
      </div>
    </div>
  );
};

export default StockOverview;
